import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

import MDTypography from "components/MDTypography";
import MediaPicker from "components/content/MediaPicker";
import StarRating from "components/content/StarRating";

/**
 * Batch 3.2 — <TestimonialFields>. The Testimonial type block. Client name and
 * company are required; the rating is constrained 1–5 by <StarRating>.
 */
function TestimonialFields({ value, onChange, websiteId }) {
  const set = (key) => (event) => onChange({ [key]: event.target.value });

  return (
    <Stack spacing={3}>
      <MDTypography variant="button" fontWeight="bold" textTransform="uppercase" color="text">
        Testimonial details
      </MDTypography>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          label="Client name"
          value={value.client_name}
          onChange={set("client_name")}
          fullWidth
          required
        />
        <TextField
          label="Client company"
          value={value.client_company}
          onChange={set("client_company")}
          fullWidth
          required
        />
      </Stack>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          label="Client position"
          value={value.client_position}
          onChange={set("client_position")}
          fullWidth
        />
        <TextField
          label="Client location"
          value={value.client_location}
          onChange={set("client_location")}
          fullWidth
        />
      </Stack>

      <StarRating value={value.rating} onChange={(rating) => onChange({ rating })} />

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          label="Project type"
          value={value.project_type}
          onChange={set("project_type")}
          fullWidth
        />
        <TextField
          label="Project date"
          type="date"
          value={value.project_date}
          onChange={set("project_date")}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Stack>

      <MediaPicker
        label="Client photo"
        value={value.client_photo}
        onChange={(id) => onChange({ client_photo: id })}
        websiteId={websiteId}
        visibility="public"
        accept="image/*"
      />
    </Stack>
  );
}

TestimonialFields.defaultProps = {
  websiteId: undefined,
  context: {},
};

TestimonialFields.propTypes = {
  value: PropTypes.shape({
    client_name: PropTypes.string,
    client_company: PropTypes.string,
    client_position: PropTypes.string,
    client_location: PropTypes.string,
    rating: PropTypes.number,
    project_type: PropTypes.string,
    project_date: PropTypes.string,
    client_photo: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  context: PropTypes.object,
};

export default TestimonialFields;
